import { useEffect, useState } from 'react'
import { Box, Card, Typography, useMediaQuery } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { CardFiltration, FiltrationAutocomplete, FiltrationTitle } from './style'
import { FormBlock } from '../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { PureLightTheme } from '../../../styles/theme'
import { TEXT_FILTER_DEBOUNCE_MS } from '../../../consts/filtration'

const normalizeStringFilter = (value: unknown): string | undefined => {
  const normalized = String(value ?? '').trim()
  if (!normalized || normalized === 'all') {
    return undefined
  }
  return normalized
}

export const ProjectsFiltration = () => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const { watch } = useFormContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const search = watch('search')
  const typeProject = watch('typeProject')
  const stage = watch('stage')
  const [debouncedSearch, setDebouncedSearch] = useState(search)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedSearch(search)
    }, TEXT_FILTER_DEBOUNCE_MS)

    return () => window.clearTimeout(timeoutId)
  }, [search])

  useEffect(() => {
    const nextParams = new URLSearchParams(searchParams)
    const normalizedQuery = normalizeStringFilter(debouncedSearch)
    const normalizedType = normalizeStringFilter(typeProject)
    const normalizedStage = normalizeStringFilter(stage)

    const syncParam = (key: string, value?: string) => {
      if (value) {
        nextParams.set(key, value)
      } else {
        nextParams.delete(key)
      }
    }

    syncParam('query', normalizedQuery)
    syncParam('type', normalizedType)
    syncParam('stage', normalizedStage)

    if (nextParams.toString() !== searchParams.toString()) {
      setSearchParams(nextParams, { replace: true })
    }
  }, [debouncedSearch, typeProject, stage, searchParams, setSearchParams])

  return (
    <Card variant='primaryCard' sx={CardFiltration}>
      {!isMobile && (
        <Box mb={{ md: 2.5 }}>
          <FormBlock formFieldConfig={getFormConfig('search')} />
        </Box>
      )}
      <Typography variant='h4' sx={FiltrationTitle}>Сортировать по:</Typography>
      <Box sx={FiltrationAutocomplete}>
        <FormBlock formFieldConfig={getFormConfig('typeProject')} />
      </Box>
      <Typography variant='h4' sx={FiltrationTitle}>Текущий этап проекта:</Typography>
      <Box sx={FiltrationAutocomplete}>
        <FormBlock formFieldConfig={getFormConfig('stage')} />
      </Box>
      {/* <Typography variant='h4' sx={FiltrationTitle}>Направленность проектов:</Typography>
      <FormBlock formFieldConfig={getFormConfig('projectFocus')} /> */}
    </Card>
  )
}
